import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Vsl } from './components/Vsl';
import { Gap } from './components/Gap';
import { System } from './components/System';
import { WhyGrowth } from './components/WhyGrowth';
import { Authority } from './components/Authority';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-ink-950 font-sans text-zinc-200" data-id="element-0" data-mp="2rlf6csv3xo2u">
      <Nav data-id="element-1" data-mp="2mmvj8p4s268w" />
      <main data-id="element-2" data-mp="2mn5fgugf19n1">
        <Hero data-id="element-3" data-mp="2mnnhy8to8k3e" />
        <Vsl data-id="element-4" data-mp="2mjzmh44o1nm1" />
        <Gap data-id="element-5" data-mp="31aqf2ee30qq7" />
        <System data-id="element-6" data-mp="31b8ka0iq2fa9" />
        <WhyGrowth data-id="element-7" data-mp="31bs27h8dh3oa" />
        <Authority data-id="element-8" data-mp="31c9vq63nh3si" />
        <FinalCta data-id="element-9" data-mp="31ctflscv2296" />
      </main>
      <Footer data-id="element-10" data-mp="2wk9y4kb1ymz3" />
    </div>;
}